"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authConfig = void 0;
const IAM_HOST = process.env.JB_IAM_HOST || "https://iam.justblink.com.pl";
const MGMT_HOST = process.env.JB_MGMT_HOST || "https://mgmt.justblink.com.pl";
exports.authConfig = {
    authority: `${IAM_HOST}/auth/realms/justblink`,
    client_id: "jb-user-mgmt-app-v1",
    redirect_uri: MGMT_HOST,
    post_logout_redirect_uri: MGMT_HOST,
    response_type: "code",
    scope: "openid profile email",
};
